import Getintouch from '../components/getintouch.js';
import Smb from '../components/smallbanner.js';
import Conta from '../components/contactinfo.js';

export default function Contactus(){
    return (
        <div>
            <Smb />
            <h2 className="p-5">Contact Us</h2>
            <Conta />
            <Getintouch />
            
        </div>
    );
}